import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { ValueToRadio } from '../components/Form/components/NumberOrNoAnswerRadioGroup';

// Hooks
import { useEnumDataSet } from '../components/Form/hooks/useEnumDataSet';

// Types
import { IQuestionConfig } from '../manifests/types';

export const useDisplayManifestAnswer = () => {
    const { getTranslatedEnumValue } = useEnumDataSet();
    const { t: commonTranslations } = useTranslation('common');

    const formatManifestAnswer = React.useCallback(
        (
            value: any,
            questionConfig: IQuestionConfig,
            ancillaryData?: Record<string, any>
        ): string | React.ReactNode => {
            if (!questionConfig) return;
            if (questionConfig?.displayValueAs) {
                return questionConfig.displayValueAs(value, ancillaryData);
            } else if (typeof questionConfig?.dataSetKey !== 'undefined' && value) {
                return Array.isArray(value)
                    ? value.map((val) => getTranslatedEnumValue(questionConfig.dataSetKey as string, val)).join(', ')
                    : getTranslatedEnumValue(questionConfig?.dataSetKey, value);
            } else if (questionConfig.component === 'NumberOrNoAnswerRadioGroup' && typeof value !== 'undefined') {
                return Object.hasOwn(ValueToRadio, value.toString())
                    ? getTranslatedEnumValue('YES_OR_NO', ValueToRadio[value.toString() as '-1' | '-2'])
                    : value;
            } else if (typeof value === 'boolean' || questionConfig.component === 'YesNoRadio') {
                return commonTranslations(value ? 'yes' : 'no');
            }

            return value ?? '--';
        },
        [getTranslatedEnumValue]
    );

    return { formatManifestAnswer };
};

export default useDisplayManifestAnswer;
